<template>
    <div class="org-select-tree-list">
        <org-tree
            ref="orgTree"
            v-bind="$attrs"
            :selected="currentSelected"
            :cust-get-tree-data="custGetTreeData"
            @selectedChange="selectedChange"
        />
    </div>
</template>

<script>
import OrgTree from '@/components/vm-tree-org';

export default {
  components: {
    OrgTree,
  },

  props: {
    selected: {
      type: Array,
      default() {
        return [];
      },
    },

    custFetchTree: {
      type: Function,
      default: null,
    },
  },

  data() {
    return {
      currentSelected: [],
      custGetTreeData: null,
    };
  },

  watch: {
    selected(nextValue) {
      this.setCurrentSelectedVal(nextValue);
    },
  },

  created() {
    this.custFetchTreeHandle();
    this.setCurrentSelectedVal(this.selected);
  },

  methods: {
    selectedChange(arr, nodeArr) {
      const dataArr = [];

      if (nodeArr && nodeArr.length > 0) {
        nodeArr.forEach((item) => {
          item.originData = item.data;
          const { data } = item || {};
          const { isParent, isFolder } = data;
          dataArr.push({
            ...data,
            isFolder: isParent || isFolder,
            originData: data,
          });
        });
      }

      this.$emit('change', dataArr);
    },

    setCurrentSelectedVal(arr) {
      this.currentSelected = arr;
    },

    custFetchTreeHandle() {
      this.custGetTreeData = this.custFetchTree;
    },

    getTree() {
      const $orgTree = this.$refs.orgTree;
      return {
        selectAll() {
          $orgTree.checkedItemById($orgTree.rootId);
        },

        clear() {
          $orgTree.unCheckedItemById($orgTree.rootId);
        },
      };
    },
  },
};
</script>
